const prefixPhoneNumber = (phoneCode: string | undefined, phoneNumber: string | undefined) =>
    `${phoneCode ?? ''} ${phoneNumber ?? ''}`;

export default prefixPhoneNumber;
